/* eslint-disable import/prefer-default-export */
import { useTheme } from '@mui/material/styles';
import useTranslation from 'i10n/useTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const useCommonInits = () => {
    const translate = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const select = useSelector;
    const theme = useTheme();

    return {
        translate,
        dispatch,
        location,
        params,
        navigate,
        select,
        theme,
    };
};
